export function EmptySlot() {
  return null;
}
